import React from "react";
import { Table, Checkbox } from "rsuite";

const { Cell } = Table;

export default function SelectUser({
  rowData,
  handleWorkerSelect,
  workerSelected,
  ...props
}) {
  return (
    <Cell {...props}>
      <Checkbox
        checked={
          workerSelected &&
          workerSelected.some((item) => item.Rut == rowData.Rut)
        }
        onChange={(_, checked) => handleWorkerSelect(checked, rowData)}
      />
    </Cell>
  );
}
